import { useCallback } from 'react'
import { Form } from 'antd'
import { convertToRaw } from 'draft-js'
import { useStore } from '../../../store/store'

// Câblage du formulaire d'édition d'une box variable (validation + écriture
// dans le store via updateBox sur boxVariableSelectedId). Extrait de
// FormBoxEditor pour être partagé avec le drawer d'édition rapide
// (VariableDrawer) sans dupliquer la logique onBlur/onFinish, subtile
// (remark sérialisée, valeurs tableaux fusionnées par index).
// `boxId` : cible explicite, pour les éditeurs qui ne passent pas par le
// formulaire plein écran (panel de droite d'une case à cocher / d'un choix
// sélectionné au document, où la sélection vit dans selectedBoxId).
export const useVariableBoxForm = (boxId) => {
  const updateBox = useStore(({ updateBox }) => updateBox)
  const boxVariableSelectedId = useStore(({ boxVariableSelectedId }) => boxVariableSelectedId)
  const targetBoxId = boxId ?? boxVariableSelectedId
  const [form] = Form.useForm()

  const onFinish = useCallback((values, callback) => {
    updateBox(targetBoxId, (b) => {
      if (typeof callback === "function") callback(b)
      Object.keys(values).forEach((key) => {
        if (Array.isArray(values[key])) {
          values[key].forEach((value, index) => {
            b[key][index] = {
              ...b[key][index],
              ...value
            }
          })
        }
        else {
          if (key === 'remark') {
            b[key] = JSON.stringify(convertToRaw(values[key].getCurrentContent()))
          } else {
            b[key] = values[key]
          }
        }
      })
    })
  }, [targetBoxId, updateBox])

  const validateFormAndRetrieveValues = useCallback(async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue()
      return values
    } catch (errors) {
      throw errors
    }
  }, [form])

  const onBlur = useCallback(async (callback) => {
    try {
      const values = await validateFormAndRetrieveValues()
      onFinish(values, callback)
    } catch (errors) {
    }
  }, [validateFormAndRetrieveValues, onFinish])

  return { form, onBlur, validateFormAndRetrieveValues }
}
